
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M14.467 8.933a4.534 4.534 0 11-.002 9.068 4.534 4.534 0 01.002-9.068zM8.87 9.78A3.001 3.001 0 0110 4h0a3 3 0 013 3","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M4 3a1 1 0 110 2 1 1 0 010-2z"}}),_c('path',{attrs:{"d":"M16.487 12.149l-2.195 2.926a.567.567 0 01-.854.061l-1.133-1.133","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.838 13H2.8c-.994 0-1.8-.895-1.8-2V3c0-1.105.806-2 1.8-2h14.4c.994 0 1.8.895 1.8 2v5.544","stroke-linecap":"round"}})])])
          )
        }
      }
    